"use strict";
'use es6'; // taken from https://facebook.github.io/react/docs/reusable-components.html#mixins

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.intervals = [];
  },
  setInterval: function (_setInterval) {
    function setInterval() {
      return _setInterval.apply(this, arguments);
    }

    setInterval.toString = function () {
      return _setInterval.toString();
    };

    return setInterval;
  }(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this.intervals.push(setInterval.apply(null, args));
  }),
  componentWillUnmount: function componentWillUnmount() {
    this.intervals.forEach(clearInterval);
  }
};
exports.default = _default;
module.exports = exports.default;